import PropTypes from "prop-types";
import React, { memo } from "react";
import cn from "classnames";
import { IoMdArrowDropLeft } from "../../../assets/images/icons/DropLeft";
import { IoMdArrowDropRight } from "../../../assets/images/icons/DropRight";

import styles from "./PaginationNumbers.module.scss";
import Icon from "../../Icon";

Icon.add(IoMdArrowDropLeft);
Icon.add(IoMdArrowDropRight);

function PaginationNumbers({ changePageRequest, totalAmount, currentPage, className }) {
  const changePage = ({ currentTarget: { name: newPage } }) => {
    if (newPage !== currentPage - 1) {
      // eslint-disable-next-line no-undef
      window.scrollTo(0, 0);
      changePageRequest(+newPage);
    }
  };

  const numbersWithJumps = () => (
    <>
      {currentPage > 1 && (
        <button type="button" name={0} onClick={changePage} className={styles.pageNumbers}>
          1
        </button>
      )}
      {currentPage > 3 && (
        <button type="button" name={currentPage - 3} onClick={changePage} className={styles.pageNumbers}>
          . . .
        </button>
      )}
      {currentPage >= 3 && (
        <button type="button" name={currentPage - 2} onClick={changePage} className={styles.pageNumbers}>
          {currentPage - 1}
        </button>
      )}
      <button
        type="button"
        name={currentPage - 1}
        onClick={changePage}
        className={cn(styles.pageNumbers, styles.selectedPage)}
      >
        {currentPage}
      </button>
      {totalAmount - currentPage >= 1 && (
        <button type="button" name={currentPage} onClick={changePage} className={styles.pageNumbers}>
          {currentPage + 1}
        </button>
      )}
      {totalAmount - currentPage > 2 && (
        <button type="button" name={currentPage + 1} onClick={changePage} className={styles.pageNumbers}>
          . . .
        </button>
      )}
      {currentPage < totalAmount - 1 && (
        <button type="button" name={totalAmount - 1} onClick={changePage} className={styles.pageNumbers}>
          {totalAmount}
        </button>
      )}
    </>
  );

  const paginationButtons = () => {
    if (totalAmount >= 7) {
      return numbersWithJumps();
    }
    const newPages = [];

    for (let i = 1; i <= totalAmount; i++) {
      newPages.push(i);
    }

    return newPages.map(pageNumber => (
      <button
        type="button"
        name={pageNumber - 1}
        onClick={changePage}
        className={cn(styles.pageNumbers, { [styles.selectedPage]: pageNumber === currentPage })}
        key={pageNumber}
      >
        {pageNumber}
      </button>
    ));
  };

  return (
    <>
      {totalAmount > 1 && (
        <div className={cn(styles.paginationWrap, className)}>
          <button
            type="button"
            className={styles.arrows}
            name={currentPage - 2}
            disabled={currentPage <= 1}
            onClick={changePage}
          >
            <Icon icon="arrow_left" className={styles.icon} />
          </button>
          {paginationButtons()}
          <button
            type="button"
            className={styles.arrows}
            name={currentPage}
            disabled={totalAmount === currentPage}
            onClick={changePage}
          >
            <Icon icon="arrow_right" className={styles.icon} />
          </button>
        </div>
      )}
    </>
  );
}

PaginationNumbers.propTypes = {
  totalAmount: PropTypes.number,
  currentPage: PropTypes.number,
  changePageRequest: PropTypes.func,
  className: PropTypes.string
};

PaginationNumbers.defaultProps = {
  totalAmount: 0,
  currentPage: 1,
  changePageRequest: () => {},
  className: ""
};

export default memo(PaginationNumbers);
